import * as Nav from '../../data/photoUrls';
import { BGSize } from '../../util';

export interface SideBarInfo {
  id: string;
  idDark: string;
  className: string;
  title: string;
  bg: string;
  bgLight: string;
  fontColor: string;
  hoverColor: string;
  path: string;
  icon: string;
  iconDark: string;
  bgSize: BGSize;
  filter: string;
  bgColor?: string;
}

const identifiers = ['navItem', 'navItem2', 'navItem3', 'navItem4'];
const identifiersDark = [
  'navItemDark',
  'navItem2Dark',
  'navItem3Dark',
  'navItem4Dark',
];
const selectedColors = [
  '#1e6174',
  'rgba(206, 206, 206, 0.87)',
  'rgba(45, 221, 1, 0.87)',
  'rgb(209, 111, 55, 0.87)',
];

export const sideBarInfo = (bg: string): SideBarInfo[] => [
  {
    id: identifiers[0],
    idDark: identifiersDark[0],
    title: 'Home',
    path: 'home',
    icon: Nav.homeIcon,
    iconDark: Nav.homeIconDark,
    className: 'nav-text',
    bgSize: BGSize.Cover,
    filter: '',
    bg,
    bgLight: '',
    hoverColor: selectedColors[0],
    fontColor: selectedColors[0],
    bgColor: selectedColors[0],
  },
  {
    id: identifiers[1],
    idDark: identifiersDark[1],
    title: 'Skills',
    path: 'skills',
    icon: Nav.resumeIcon,
    iconDark: Nav.resumeIconDark,
    className: 'nav-text',
    bgSize: BGSize.Contain,
    filter: '',
    bg,
    bgLight: '',
    hoverColor: selectedColors[1],
    fontColor: selectedColors[1],
    bgColor: selectedColors[1],
  },
  {
    id: identifiers[2],
    idDark: identifiersDark[2],
    title: 'Projects',
    path: 'projects',
    icon: Nav.projectsIcon,
    iconDark: Nav.projectsIconDark,
    className: 'nav-text',
    bgSize: BGSize.Contain,
    filter: '',
    bg,
    bgLight: '',
    hoverColor: selectedColors[2],
    fontColor: selectedColors[2],
    bgColor: selectedColors[2],
  },
  {
    id: identifiers[3],
    idDark: identifiersDark[3],
    title: 'Contact',
    path: 'contact',
    icon: Nav.contactIcon,
    iconDark: Nav.contactIconDark,
    className: 'nav-text',
    bgSize: BGSize.Cover,
    filter: '',
    bg,
    bgLight: '',
    hoverColor: selectedColors[3],
    fontColor: selectedColors[3],
    bgColor: selectedColors[3],
  },
];
